import EntityAvatar from './EntityAvatar';
import EntityPane, { EntityPaneBody } from './EntityPane';
import EntityPaneHeader from './EntityPaneHeader';

const Entity = {
  Pane: EntityPane,
  Header: EntityPaneHeader,
  Avatar: EntityAvatar,
  Body: EntityPaneBody,
};

export default Entity;
